import { supabaseCreateCheckoutSession } from '../supabase/supabaseCreateCheckoutSession';

const createCheckoutSession = async ({
  email, lineItem, redirects,
}) => {
  const body = new URLSearchParams({
    'line_items[0][price]': lineItem.price, // Replace with your price ID
    'line_items[0][quantity]': lineItem.quantity,
    mode: 'subscription',
    success_url: redirects.successURL, // Replace with your success URL
    cancel_url: redirects.cancelURL,
    customer_email: email, // Prefill the email address
    // TODO: Add idempotency key
  });
  const response = await supabaseCreateCheckoutSession(body.toString());
  // does this work fine in capacitor? if so, why?
  // Shash and David pretty sure this is thoroughly tested so ...
  window.location.href = response.url;
};

export { createCheckoutSession };
